import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import NavBar from "./navigation/NavBar";
import Footer from "./footer/Footer";
import CookieRulesDialog from "./cookies/CookieRulesDialog";
import CookieConsent from "./cookies/CookieConsent";
import DialogSelector from "./dialog/DialogSelector";
import Routing from "./Routing";
import smoothScrollTop from "../../shared/functions/smoothScrollTop";
import { fetchBlogPosts } from '../../shared/functions/api/blogPosts';
import { history } from "./../../App";
import { connect } from "react-redux";
import ConsecutiveSnackbarMessages from "../../shared/components/ConsecutiveSnackbarMessages";

import styled, { createGlobalStyle } from 'styled-components';

const styles = theme => ({
  wrapper: {
    overflowX: "hidden"
  },
  sandboxLine: {
    backgroundColor: 'red',
    position: 'fixed',
    height: 4,
    width: '100%',
    top: 0,
    left: 0,
    zIndex: 100000,
  }
});

const HideTrengoChat = createGlobalStyle`
#trengo-web-widget{
  display: none !important;
}
`;

class Main extends PureComponent {
  state = {
    selectedTab: null,
    mobileDrawerOpen: false,
    blogPosts: [],
    dialogOpen: null,
    dialogOpenProps: {},
    cookieRulesDialogOpen: false,
    showNavBar: true,
    scrollTop: 0,
    isBright: false, 
  };

  blogPostsMaxUnix = Math.round(new Date().getTime() / 1000);

  componentDidMount() {
    this.fetchBlogPosts('published');
  }

  selectHome = () => {
    window.scrollTo(0, 0);
    document.title =
      "Henig Diamonds";
    this.setState({ isBright: false, selectedTab: "Home", showNavBar: false });
  };

  headSectionAnimationComplete = () => {
    this.setState({ showNavBar: true });
  };

  selectBlog = (dontScrollToTop) => {
    if(!dontScrollToTop){
      smoothScrollTop();
    }
    document.title = "Henig Diamonds - News";
    this.setState({ isBright: false, selectedTab: "Blog", showNavBar: true });
  };

  selectDiamonds = () => {
    smoothScrollTop();
    document.title = "Henig Diamonds - Diamonds";
    this.setState({ isBright: true, selectedTab: "Diamonds", showNavBar: true });
  };

  selectDiamondDetails = () => {
    smoothScrollTop();
    document.title = "Henig Diamonds - Diamond Details";
    this.setState({ isBright: true, selectedTab: "DiamondDetails", showNavBar: true });
  };
  selectAll = () => {
    smoothScrollTop();
    document.title = "Henig Diamonds - All Diamonds";
    this.setState({ isBright: true, selectedTab: "All", showNavBar: true });
  };
  selectFav = () => {
    smoothScrollTop();
    document.title = "Henig Diamonds - Favourite Diamonds";
    this.setState({ isBright: true, selectedTab: "Fav", showNavBar: true });
  };
  selectCompare = () => {
    smoothScrollTop();
    document.title = "Henig Diamonds - Compare Diamonds";
    this.setState({ isBright: true, selectedTab: "Compare", showNavBar: true });
  };
  selectBag = () => {
    smoothScrollTop();
    document.title = "Henig Diamonds - Bag";
    this.setState({ isBright: true, selectedTab: "Bag", showNavBar: true });
  };

  selectJewellery = () => {
    smoothScrollTop();
    document.title = "Henig Diamonds - Jewellery";
    this.setState({ isBright: false, selectedTab: "Jewellery", showNavBar: true });
  };

  selectTAndCs = () => {
    smoothScrollTop();
    document.title = "Henig Diamonds - Terms & Conditions";
    this.setState({ isBright: false, selectedTab: "TermsAndConditions", showNavBar: true });
  };

  selectPrivacyPolicy = () => {
    smoothScrollTop();
    document.title = "Henig Diamonds - Privacy Policy";
    this.setState({ isBright: false, selectedTab: "PrivacyPolicy", showNavBar: true });
  };

  selectFAQs = () => {
    smoothScrollTop();
    document.title = "Henig Diamonds - Frequently Asked Questions";
    this.setState({ isBright: false, selectedTab: "FAQs", showNavBar: true });
  };

  selectBlogPost = (post) => {
    smoothScrollTop();
    document.title = `Henig Diamonds - ${post.title}`;
    this.setState({ isBright: false, selectedTab: "Post", showNavBar: true });
  };

  selectAboutUs = (post) => {
    smoothScrollTop();
    document.title = `Henig Diamonds - About Us`;
    this.setState({ isBright: false, selectedTab: "AboutUs", showNavBar: true });
  };

  selectContactUs = (post) => {
    smoothScrollTop();
    document.title = `Henig Diamonds - Contact Us`;
    this.setState({ isBright: false, selectedTab: "ContactUs", showNavBar: true });
  };

  selectApiPage = (post) => {
    smoothScrollTop();
    document.title = `Henig Diamonds - API`;
    this.setState({ isBright: false, selectedTab: "API", showNavBar: true });
  };

  openLoginDialog = (dialogOpenProps) => {
    this.setState({ dialogOpen: "login", mobileDrawerOpen: false, dialogOpenProps });
  };

  openEmailDialog = (dialogOpenProps, after) => {
    const { authUser } = this.props;
    if(authUser){
      history.push(authUser.role === 'user' ? "/my-account" : '/admin')
    }else{
      this.setState({ dialogOpen: "email", mobileDrawerOpen: false, dialogOpenProps });
    }
  };

  closeDialog = () => {
    this.setState({ dialogOpen: null });
  };

  openRegisterDialog = (dialogOpenProps) => {
    this.setState({
      dialogOpen: "register",
      mobileDrawerOpen: false,
      dialogOpenProps,
    });
  };

  openPasswordDialog = (dialogOpenProps) => {
    this.setState({
      dialogOpen: "password",
      mobileDrawerOpen: false,
      dialogOpenProps,
    });
  };

  handleMobileDrawerOpen = () => {
    this.setState({ mobileDrawerOpen: true });
  };

  handleMobileDrawerClose = () => {
    this.setState({ mobileDrawerOpen: false });
  };

  openChangePasswordDialog = (dialogOpenProps) => {
    this.setState({
      dialogOpen: "changePassword",
      dialogOpenProps,
    });
  };

  openMessageDialog = (dialogOpenProps) => {
    this.setState({
      dialogOpen: "message",
      dialogOpenProps,
    });
  };

  fetchBlogPosts = async (status) => {
    const blogPosts = await fetchBlogPosts(status);
    const lastPost = blogPosts[blogPosts.length - 1];
    this.blogPostsMaxUnix = lastPost ? lastPost.date : new Date();

    this.setState({
      blogPosts
    });
  };

  handleCookieRulesDialogOpen = () => {
    this.setState({ cookieRulesDialogOpen: true });
  };

  handleCookieRulesDialogClose = () => {
    this.setState({ cookieRulesDialogOpen: false });
  };

  onHomeSectionsScroll(scrollTop) {
    this.setState({ scrollTop })
  }

  /**
   * We have to call the pushSnackBarMessage function of this
   * child's consecutiveSnackbarMessages component. Thats why we pass it
   * when the component did mount to this components state.
   */
   getPushMessageFromChild = pushFunction => {
    this.pushMessageToSnackbar = pushFunction;
  };

  render() {
    const { classes, noLayout } = this.props;
    const {
      selectedTab,
      mobileDrawerOpen,
      blogPosts,
      dialogOpen,
      cookieRulesDialogOpen,
      showNavBar,
      scrollTop,
      dialogOpenProps,
      isBright,
    } = this.state;

    const isSandbox = document.location.href.includes('sandbox.henigdiamonds.co.uk')

    return (
      <div className={classes.wrapper}>
        {isSandbox && <div className={classes.sandboxLine}></div>}

        {!cookieRulesDialogOpen && !noLayout &&(
          <CookieConsent
            handleCookieRulesDialogOpen={this.handleCookieRulesDialogOpen}
          />
        )}
        <DialogSelector
          openLoginDialog={this.openLoginDialog}
          dialogOpen={dialogOpen}
          onClose={this.closeDialog}
          openRegisterDialog={this.openRegisterDialog}
          openPasswordDialog={this.openPasswordDialog}
          openEmailDialog={this.openEmailDialog}
          openChangePasswordDialog={this.openChangePasswordDialog}
          openMessageDialog={this.openMessageDialog}
          dialogOpenProps={dialogOpenProps}
        />
        <CookieRulesDialog
          open={cookieRulesDialogOpen}
          onClose={this.handleCookieRulesDialogClose}
        />
        {!noLayout && <NavBar
          selectedTab={selectedTab}
          openEmailDialog={this.openEmailDialog}
          openLoginDialog={this.openLoginDialog}
          openRegisterDialog={this.openRegisterDialog}
          mobileDrawerOpen={mobileDrawerOpen}
          handleMobileDrawerOpen={this.handleMobileDrawerOpen}
          handleMobileDrawerClose={this.handleMobileDrawerClose}
          showNavBar={showNavBar}
          scrollTop={scrollTop}
          isBright={isBright}
        />}
        <ConsecutiveSnackbarMessages
          getPushMessageFromChild={this.getPushMessageFromChild}
        />
        <Routing
          blogPosts={blogPosts}
          selectHome={this.selectHome}
          openLoginDialog={this.openLoginDialog}
          openPasswordDialog={this.openPasswordDialog}
          openMessageDialog={this.openMessageDialog}
          openEmailDialog={this.openEmailDialog}
          closeDialog={this.closeDialog}
          headSectionAnimationComplete={this.headSectionAnimationComplete}
          selectBlog={this.selectBlog}
          selectDiamonds={this.selectDiamonds}
          selectDiamondDetails={this.selectDiamondDetails}
          selectAll={this.selectAll}
          selectFav={this.selectFav}
          selectCompare={this.selectCompare}
          selectBag={this.selectBag}
          selectJewellery={this.selectJewellery}
          selectTAndCs={this.selectTAndCs}
          selectPrivacyPolicy={this.selectPrivacyPolicy}
          selectFAQs={this.selectFAQs}
          selectBlogPost={this.selectBlogPost}
          selectAboutUs={this.selectAboutUs}
          selectContactUs={this.selectContactUs}
          selectApiPage={this.selectApiPage}
          onHomeSectionsScroll={scrollTop => this.onHomeSectionsScroll(scrollTop)}
          pushMessageToSnackbar={this.pushMessageToSnackbar}
          openRegisterDialog={this.openRegisterDialog}
        />
        {// for the Home page the footer is embedded into the home container
          selectedTab !== 'Home' && !noLayout &&
          <Footer openEmailDialog={this.openEmailDialog}/>
        }
        {noLayout && <HideTrengoChat />}
      </div>
    );
  }
}

Main.propTypes = {
  classes: PropTypes.object.isRequired
};


export default connect(
  (state) => ({
    authUser: state.auth.user,
  }),
)(withStyles(styles, { withTheme: true })(Main));
